import { Formik } from 'formik';
import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { account } from '@redux/account';
import { Input } from 'components/Form/Input';
import { Button } from 'components/Button/Button';
import { Alert } from 'components/Alert';
import { Link } from 'components/Link/Link';
import { useDispatch } from 'utils/useDispatch';


export const Reset = () => {
  const { t } = useTranslation();
  const hasError = useSelector(account.selectors.hasError);
  const firstError = useSelector(account.selectors.firstError);
  const responseMessage = useSelector(account.selectors.responseMessage);

  const forgotPassword = useDispatch(account.actions.forgotPassword);

  const handleForgotPassword = useCallback(async (values, { setSubmitting }) => {
    await forgotPassword(values);
    setSubmitting(false);
  }, [forgotPassword]);

  return (
    <>
      <header className="mb-6 text-center">
        <h1 className="text-xl font-semibold text-ui">{t('auth.resetTitle')}</h1>
        <p className="mt-2 text-ui-3">{t('auth.resetHint')}</p>
      </header>
      { hasError && <Alert className="mb-5" type="danger">{firstError}</Alert> }
      { responseMessage && <Alert className="mb-5" type="success">{responseMessage}</Alert>}
      <Formik
        initialValues={{
          email: '',
          password: '',
        }}
        onSubmit={handleForgotPassword}
      >
        {({ values, handleChange, handleSubmit, isSubmitting }) => (
          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <Input
                className="w-full"
                size="small"
                type="email"
                name="email"
                label={t('fields.email')}
                placeholder={t('fields.emailPlaceholder')}
                onChange={handleChange}
                value={values.email}
                required
              />
            </div>
            <Button
              type="submit"
              view="cta"
              isDisabled={isSubmitting || Boolean(responseMessage)}
              className="h-10 text-sm"
              center
              block
            >{t('auth.resetButton')}</Button>
          </form>
        )}
      </Formik>
      <div className="mt-8 text-center text-ui-3">
        <Link className="text-ui underline decoration-ui-3 underline-offset-4 hover:decoration-ui" to="/auth/login">{t('auth.backToLogin')}</Link>
      </div>
    </>
  )
}
